import { c as _c } from "react/compiler-runtime";
import type { ButtonMessage } from "@/types/agent/message";
import { SpeechBubble } from "./SpeechBubble";
interface AgentButtonMessageProps {
  message: ButtonMessage;
}
export const AgentButtonMessage: React.FC<AgentButtonMessageProps> = t0 => {
  const $ = _c(3);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message.action || $[1] !== message.text) {
    t1 = <SpeechBubble sender="assistant" className="flex items-center gap-4 min-w-fit"><button className="inline-block px-4 py-2 bg-yellow text-black rounded-full font-bold hover:bg-yellow/80 transition-colors" onClick={message.action} aria-label={message.text}>{message.text}</button></SpeechBubble>;
    $[0] = message.action;
    $[1] = message.text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};